import { render, staticRenderFns } from "./DishOrdersBK.vue?vue&type=template&id=6b96069a&scoped=true&"
import script from "./DishOrdersBK.vue?vue&type=script&lang=js&"
export * from "./DishOrdersBK.vue?vue&type=script&lang=js&"
import style0 from "./DishOrdersBK.vue?vue&type=style&index=0&id=6b96069a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96069a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VLayout,VSnackbar})
